import { BaseDataService } from "../../../services/base/BaseDataService";
import { withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { ModelAction } from "../../../types/responses/ModelAction";
import { ProjectDoc } from "../models/ProjectDoc";
import { ProjectDocQuery } from "../models/ProjectDocQuery";

export class ProjectDocService extends BaseDataService<ProjectDoc, ProjectDocQuery> {
  protected prefixUrl: string = `ProjectDocs`;

  actions(id: number) {
    return this.api.get<ModelAction[]>(`${this.prefixUrl}/Actions?id=${id}`);
  }

  referenceReport(id: number) {
    return this.api.get<any>(`${this.prefixUrl}/referenceReport?id=${id}`);
  }

  projectConsolidated(id: number) {
    return this.api.get<any>(`${this.prefixUrl}/projectConsolidated?id=${id}`);
  }

  downloadReferenceReport(id: number) {
    return this.downloadFile(`${this.prefixUrl}/ReferenceReportDownload?id=${id}`);
  }

  downloadProjectConsolidated(id: number) {
    return this.downloadFile(`${this.prefixUrl}/ProjectConsolidatedDownload?id=${id}`);
  }

  editSigner(data: IProjectDocEditSigner) {
        if (typeof data.ContractSignerBasisDocument?.Content === 'string') {
            return this.api.post<ProjectDoc>(`${this.prefixUrl}/EditSigner`, data, withUploadRejectionDetection());
        }
		return this.api.post<ProjectDoc>(`${this.prefixUrl}/EditSigner`, data);
	}

  
  async downloadContractSignerBasisDocument(id: number){
    return this.downloadFile(`${this.prefixUrl}/DownloadContractSignerBasisDocument?id=${id}`);
  }
}

export interface IProjectDocEditSigner {
  Id?: number;
  ContractSignerFullName?: string;
  ContractSignerJobTitle?: string;
  ContractorTasksDueDate?: Date;
  ContractorSignDueDate?: Date;
  ContractSignerBasisDocument?: IProjectDocEditSignerAttachment;
}

export interface IProjectDocEditSignerAttachment{
  Id?: string;
  FileName?: string;
  Size?: number;
  ContentType?: string;
  Content?: string;
}
